var windowWidth = document.documentElement.clientWidth,
    swipersJSON = new Object(),
    related;

window.addEventListener('resize', () => {
    windowWidth = document.documentElement.clientWidth;
});

if (status1) {
    mmLoader({
        src: "https://www.giallozafferano.it/js/min/foglia-logged.min.js?cb=" + nonce,
        async: true
    }, "leafChainLogged")
    mmLoader({
        src: "https://www.giallozafferano.it/js/dropzone.min.js",
        async: true
    }, "leafChainLogged")
    .then(element => mmLoader({
        src: "https://www.giallozafferano.it/js/min/user-chiedi-a-giallo-form.min.js?cb=" + nonce,
        async: true
    }, "leafChainLogged"))
    .then(element => initDropzone());
}

function initContentPlayer(videoId, playerDelay, consent=true) {

    const createVideoScript = (click_evt = false) => {

        if (!playerContentConfig.checked){
            (function (a,l,t,e,r) {
                a[e] = a[e] || function(s) { (a[e].run = a[e].run || []).push(s)};
                let g,z = l.getElementsByTagName(t)[0];
                if (l.getElementById(e)){return;}
                g = l.createElement(t); g.id = e; g.src = r; g.async = 1;
                z.parentNode.insertBefore(g,z);
            }(window, document, 'script', 'AVPushLoader', "https://ptp.stbm.it/pushdown/loader/av/pushdown-loader.js"));

            let hasAdv = true;
            hasAdv = noAdvVideo ? false : true;
            if(is_massari || !consent) {
                hasAdv = false;
            }
            AVPushLoader({
                website: (lang == 'it') ? "gzfg" : "gcfg",
                adServer: (lang == 'it') ? "freewheel" : "ima",
                advFallbacks: (lang == 'it') ? true : false,
                mode: "content",
                audioModeOn: audioModeOnSentinel,
                videoId,
                preferMaxQuality: true,
                contentAutoplay:click_evt,
                flyMode: "fade",
                targetElementId: "Flyingvid",
                hasAdv,
                fwPauseOnVisibilityChange: !isMobile ? false : true,
                imaForcePlayOnVisibilityChange: isMobile ? false : true
            });

            console.log('Test VTR');

            if (click_evt || audioModeOnSentinel){
                window.addEventListener('content_played', () =>{
                    AVPushRunningInstances[0].api.setVolume(0.05);
                });

                window.addEventListener('preroll_started', () =>{
                    setTimeout(function () {
                        // audio on solo se la chat AI non è aperta
                        const chatAiOpened = document.getElementById('ai-assist');
                        if (chatAiOpened.classList.contains('minimized')){
                            AVPushRunningInstances[0].api.setVolume(0.05);

                            window.addEventListener("chatAIOpened", () => {
                                console.log('[Check AudioOn] evento chat aperta, setto volume a 0');
                                AVPushRunningInstances[0].api.setVolume(0.00);
                            });
                        }
                    },200);
                });
            }

            playerContentConfig.checked = true;
        }
    }

    setTimeout(function () {injectAudioSentinel().then(()=>createVideoScript())},playerDelay);

    targetFV.addEventListener('click', () => {
        createVideoScript(click_evt=true);
        playerContentConfig.checked = true;
    });
}

let noAdvVideo;
if (typeof playerContentConfig === 'object'){
    let delay = is_massari ? 0 : playerContentConfig.playerDelay;
    postTcfReady(() => initContentPlayer(playerContentConfig.videoId, delay));
    postConsentRejected(() => {
        initContentPlayer(playerContentConfig.videoId, delay,consent=false)}
    );
}

(moveContent = () => {
    var myArray = [];

    for (const el of document.querySelectorAll('.gz-move-content')) {
        myArray.push({
            moveFrom: el.dataset.moveFrom,
            moveIn: el.dataset.moveIn,
            content: el.innerHTML
        });
    }

    if (windowWidth >= 1000) {
        for (const val of myArray) {
            if (val.moveFrom == 'mobile') {
                let content = val.content.replace(new RegExp('gz-button-translations-selected', 'g'), 'gz-button-translations-selected-desktop');
                document.querySelector(val.moveIn).innerHTML = content;
            }
        }
    }

    for (const val of myArray) {
        if (val.moveFrom == 'all') {
            document.querySelector(val.moveIn).innerHTML = val.content;
        }
    }
    setTimeout(() => {
        document.querySelectorAll('.gz-list-macros').forEach(function (item) {
            item.classList.add('done');
        });
    }, 300);

})();

(copyContent = () => {
    for (const el of document.querySelectorAll('.gz-copy-content')) {
        el.innerHTML = document.querySelector(el.dataset.copyFrom).innerHTML;
    }
})();

/*Inserisco l'argomento closureClass, così da wrappare la classe gz-more-share utile al
funzionamento dei social dell'infinite scroll.*/
(populateOverlaySocial = (closureClass = '') => {
    var html = `<a target="new" class="gz-overlay-more-share-button gz-button-shareFB" href="#" data-social="Facebook">
                    <span class="gz-icon">
                        <svg viewBox="0 0 28 28">
                            <use xlink:href="/style/images/icons-foglia.svg?cb=${nonce}#share-facebook" />
                        </svg>
                    </span>
                </a>
                <a target="new" class="gz-overlay-more-share-button gz-button-sharePT" href="#" data-social="Pinterest">
                    <span class="gz-icon">
                        <svg viewBox="0 0 28 28">
                            <use xlink:href="/style/images/icons-foglia.svg?cb=${nonce}#share-pinterest" />
                        </svg>
                    </span>
                </a>
                <a target="new" class="gz-overlay-more-share-button gz-hide-desktop gz-button-shareMSG" href="#" data-social="FB Messenger">
                    <span class="gz-icon">
                        <svg viewBox="0 0 28 28">
                            <use xlink:href="/style/images/icons-foglia.svg?cb=${nonce}#share-messenger" />
                        </svg>
                    </span>
                </a>
                <a target="new" class="gz-overlay-more-share-button gz-button-shareTW" href="#" data-social="X">
                    <span class="gz-icon">
                        <svg viewBox="0 0 36 36">
                            <use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-share-x-noborder" />
                        </svg>
                    </span>
                </a>
                <a target="new" class="gz-overlay-more-share-button gz-hide-desktop gz-button-shareWA" href="#" data-social="Whatsapp">
                    <span class="gz-icon">
                        <svg viewBox="0 0 28 28">
                            <use xlink:href="/style/images/icons-foglia.svg?cb=${nonce}#share-whatsapp" />
                        </svg>
                    </span>
                </a>
                <span class="gz-icon gz-icon-close">
                    <svg viewBox="0 0 50 50">
                        <use xlink:href="/style/images/icons.svg?cb=${nonce}#icon-close" />
                    </svg>
                </span>`;

    for (const el of document.querySelectorAll(`${closureClass} .gz-more-share`)) {

        let element = el;
        let moreShareDiv = document.createElement('div');
        moreShareDiv.setAttribute('class', 'gz-overlay-more-share');
        moreShareDiv.innerHTML = html;

        element.appendChild(moreShareDiv);

        element.querySelector(':scope a').addEventListener('click', event => {
            //alert('test')
            event.preventDefault();
            if (navigator.share && ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
                navigator.share({
                        title: document.querySelector('meta[property="og:title"]').getAttribute('content'),
                        text: document.querySelector('meta[property="og:description"]').getAttribute('content'),
                        url: document.querySelector('meta[property="og:url"]').getAttribute('content')
                    })
                    .catch(console.error);
            } else {
                element.classList.toggle('opened');
            }
        });

        element.querySelector(':scope .gz-icon-close').addEventListener('click', event => {
            event.preventDefault();
            element.classList.toggle('opened');
        });
    }
})();

(populateSocial = () => {
    let urlToShare = document.querySelector('meta[property="og:url"]').getAttribute('content'),
        imageToShare = document.querySelector('meta[property="og:image"]').getAttribute('content'),
        imageVerticalToShare = imageToShare.replace("650x433_wm", "428x532"),
        titleToShare = document.querySelector('meta[property="og:title"]').getAttribute('content'),
        descriptionToShare = document.querySelector('meta[property="og:description"]').getAttribute('content');


    let buttonsShareFB = document.querySelectorAll('.gz-button-shareFB'),
        buttonsShareWA = document.querySelectorAll('.gz-button-shareWA'),
        buttonsSharePT = document.querySelectorAll('.gz-button-sharePT'),
        buttonsShareMSG = document.querySelectorAll('.gz-button-shareMSG'),
        buttonsShareTW = document.querySelectorAll('.gz-button-shareTW');

    for (const el of buttonsShareFB) {
        el.setAttribute('href', 'http://www.facebook.com/sharer/sharer.php?u=' + urlToShare);
    }

    for (const el of buttonsSharePT) {
        el.setAttribute('href', 'https://www.pinterest.com/pin/create/button/?url=' + urlToShare + '&media=' + imageVerticalToShare + '&description=' + descriptionToShare + '');
    }

    for (const el of buttonsShareWA) {
        el.setAttribute('href', 'whatsapp://send?text=' + dictionary.readHere + ': ' + titleToShare + ' - ' + urlToShare);
    }

    for (const el of buttonsShareMSG) {
        el.setAttribute('href', 'fb-messenger://share?link=' + urlToShare);
    }

    for (const el of buttonsShareTW) {
        el.setAttribute('href', 'https://twitter.com/intent/tweet?text=' + titleToShare + '%20' + urlToShare);
    }
})();

let adsenseCheck = () => {
    if (initAdsenseDone) {
        adsensePush();
    } else {
        document.addEventListener('loadedAdsense', () => {
            adsensePush();
        });
    }
}

(initFoglia = () => {
    // init outbrain
    if (showLeafAds && !status2) {
        let placeholderAdsense = document.getElementById("gz-adsense-placeholder");
        if (placeholderAdsense && device != "desktop") {
            placeholderAdsense.innerHTML = `<div class="gz-adv-adsense"><ins class="adsbygoogle" style="display:block" data-ad-format="fluid" data-ad-layout-key="-73+d1-24-z+jf" data-ad-client="ca-pub-7835681492882497" data-ad-slot="9627955261"></ins></div>`;
            adsenseCheck();
        }
    }

    // init rating
    const ratings = {};
    document.querySelectorAll('.rating_panel').forEach((element, index) => {
        ratings[index] = new ratingContent(element);
        ratings[index].init(element);
    });

    // caricamento related
    if (windowWidth >= 1000 && document.querySelector('.gz-overlay-related')) {
        related = new relatedRecipes();
        related.init();
    }

    // caricamento "fatte da voi"
    if (document.querySelector('#gz-photocomments-template')) {
        const photoCommentsHandler = (entries) => {
            if (entries[0].isIntersecting) {
                appendPhotoComments();
                document.addEventListener('initSwiper', (event) => {
                    if (event.detail.swipername == "gz-photocomments-swiper") {
                        var photoComments = new loadingPhotoComments();
                        photoComments.init();
                    }
                });

                photoCommentsObserver.unobserve(photoCommentsTrigger);
            }
        };
    
        const photoCommentsObserver = new window.IntersectionObserver(photoCommentsHandler);
        let photoCommentsTrigger = document.querySelector('#gz-photocomments-trigger');
        if(photoCommentsTrigger) {
            photoCommentsObserver.observe(photoCommentsTrigger);
        }
    }

    // caricamento "podcast"
    if (document.querySelector('#gz-podcast-template')) {
        if(window.location.hash == "#open-podcast") {
            activateTemplatePodcast();
        } else {
            const podcastHandler = (entries) => {
                if (entries[0].isIntersecting) {
                    activateTemplatePodcast();
                    podcastObserver.unobserve(podcastTrigger);
                }
            };
        
            const podcastObserver = new window.IntersectionObserver(podcastHandler);
            let podcastTrigger = document.querySelector('#gz-podcast-trigger');
            if(podcastTrigger) {
                podcastObserver.observe(podcastTrigger);
            }
        }
    }

    // GZ-935 forzo il loading di tutte le immagini prima della finestra di stampa
    window.addEventListener("beforeprint", (e) => {
        const images = document.querySelectorAll('img[loading="lazy"]');
        for (const img of images) {
            img.src = img.dataset.src;
        }
    });

    const ps = document.querySelectorAll('.gz-text-expanded');
    const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
            entry.target.classList[entry.target.scrollHeight > entry.contentRect.height ? 'add' : 'remove']('gz-text-truncated');
        }
    });

    for (const p of ps) {
        observer.observe(p);
    }

    if (lang == "it") {
        var hash = window.location.hash.substr(1);

        if (typeof (hash) == "string" && hash.indexOf('anchor=') !== -1) {
            var hashID = hash.split('anchor=');

            anchorLink('#' + hashID[1], 0);

            setTimeout(function () {
                anchorLink('#' + hashID[1], 0);

                history.pushState("", document.title, window.location.pathname + window.location.search);
            }, 3000);
        }

        const raccomandatoreHandler = (entries) => {
            if (entries[0].isIntersecting) {
                addRaccomandatoreGetter();
                raccomandatoreObserver.unobserve(raccomandatoreTrigger);
            }
        };

        const raccomandatoreObserver = new window.IntersectionObserver(raccomandatoreHandler);
        let raccomandatoreTrigger = document.getElementById("gz-raccomandatore-trigger");
        if(raccomandatoreTrigger) {
            raccomandatoreObserver.observe(raccomandatoreTrigger);
        }
    } else {
        if(document.getElementById("gz-disclaimer-trigger")) {
            const disclaimerHandler = (entries) => {
                if (entries[0].isIntersecting) {
                    addDisclaimer();
                    disclaimerObserver.unobserve(disclaimerTrigger);
                }
            };
    
            const disclaimerObserver = new window.IntersectionObserver(disclaimerHandler);
            let disclaimerTrigger = document.getElementById("gz-disclaimer-trigger");
            if(disclaimerTrigger) {
                disclaimerObserver.observe(disclaimerTrigger);
            }
        }
    }
})();

(addRaccomandatoreTracker = () => {
    if (lang == "it") {
        console.log('[Raccomandatore] Consent Given');
        postTcfReady(startTracker);

        function startTracker() {
            if (document.location.host !== 'ricette.giallozafferano.it' && document.location.host !== 'www.giallozafferano.it')  return false;

            let iframeRacTracker = document.createElement('iframe');
            let src = new URL('https://ricette.giallozafferano.it/static/iframeRaccomandatoreTracker.html');
            src.searchParams.set('urlRewrited', document.location.pathname.replace('/', '').replace('.html', ''));
            iframeRacTracker.setAttribute('src', src.href);
            iframeRacTracker.setAttribute('class', 'iframeRacTracker');
            iframeRacTracker.setAttribute('width', 0);
            iframeRacTracker.setAttribute('height', 0);

            document.body.appendChild(iframeRacTracker);
        }
    }
})();

(bindHandlers = () => {
    // bind ancore
    for (const el of document.querySelectorAll("a[data-anchor]")) {
        el.addEventListener('click', event => {
            event.preventDefault();
            anchorLink(el.dataset.anchor);
        });
    }

    // bind "mostra commenti"
    if (document.getElementById('comments-more')) {
        document.getElementById('comments-more').addEventListener('click', event => {
            event.preventDefault();
            loadingComments(document.getElementById('comments-more'));
        });
    }

    // bind click su step ricetta
    for (const el of document.querySelectorAll('.gz-content-recipe-step img')) {
        el.addEventListener('click', event => {
            if (windowWidth <= 480) {
                el.closest('.gz-content-recipe-step-img-container').classList.toggle('zoom');
            }
        });
    }

    // bind +info in info ricetta
    if (document.querySelector('.gz-featured-data-recipe .gz-more-calories')) {
        document.querySelector('.gz-featured-data-recipe .gz-more-calories').addEventListener('click', event => {
            event.preventDefault();
            event.target.closest('.gz-featured-data-recipe').classList.toggle('opened');
        });
    }

    // bind +info in blocco ingredienti
    if (document.querySelector('.gz-ingredients .gz-more-calories')) {
        document.querySelector('.gz-ingredients .gz-more-calories').addEventListener('click', event => {
            event.preventDefault();
            event.target.closest('.gz-ingredients').classList.toggle('opened');
        });
    }

    //click sui correlati
    if (document.querySelectorAll('.gz-card-related a').length > 0) {
        for (const el of document.querySelectorAll('.gz-card-related a')) {
            el.addEventListener('click', event => {
                var index = el.closest('.gz-card-related').dataset.index;
                var href = el.getAttribute('href');
                eventAnalytics('Click', 'Correlati', index + '#' + href);
            });
        }
    }

    //click su stampa
    if (document.querySelector('.gz-button-print')){
        document.querySelector('.gz-button-print').addEventListener('click', event => {
            eventAnalytics('Stampa', 'Interazione', 'Click bottone sotto');
        })
    }

    if (document.querySelectorAll('.gz-card-related-top a').length > 0) {
        for (const el of document.querySelectorAll('.gz-card-related-top a')) {
            el.addEventListener('click', event => {
                var index = parseInt(el.closest('.gz-card-related-top').dataset.index) + 1;
                var href = el.getAttribute('href');
                eventAnalytics('Click', 'Correlati_top', index + '#' + href);
            });
        }
    }

    // click su "canale whatsapp"
    let whatsAppChannelLink = document.getElementById("gz-whatsapp-channel-link");
    if (whatsAppChannelLink) {
        whatsAppChannelLink.addEventListener('click', event => {
            eventAnalytics('Click su canale WhatsApp', 'Interazione', window.location.href);
        });
    }
    
    // click su "lingue"
    for (const el of document.querySelectorAll(".gz-button-translations-lang")) {
        el.addEventListener('click', event => {
            eventAnalytics('Click su bandierine in foglia', 'Interazione', el.dataset.lang);
        });
    }

    // click su "link traduzione inglese"
    let translationLink = document.getElementById("gz-translation-link");
    if (translationLink) {
        translationLink.addEventListener('click', event => {
            eventAnalytics('Click su leggi la ricetta in inglese', 'Interazione', window.location.href);
        });
    }

    if (navigator.share && ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
        for (const el of document.querySelectorAll('.gz-more-share')) {
            el.addEventListener('click', event => {
                var pos = el.dataset.shareposition;
                eventAnalytics('click_' + pos, 'Condividi', "native mobile");
            });
        }
    } else {
        for (const el of document.querySelectorAll('.gz-overlay-more-share-button')) {
            el.addEventListener('click', event => {
                var pos = el.closest('.gz-more-share').dataset.shareposition;
                var social = el.dataset.social;
                eventAnalytics('click_' + pos, 'Condividi', social);
            });
        }
    }

    for (const button of document.querySelectorAll('.gz-buttons-wrap a[data-event-action]')) {
        button.addEventListener('click', function () {
            eventAnalytics('click_top', 'Condividi', button.getAttribute('data-event-action'), document.URL);
        });
    }

    if (lang == "it") {
        if (!status1) {
            document.addEventListener('click', function (event) {
                for (var target = event.target; target && target != this; target = target.parentNode) {
                    if (target.matches('.gz-button-condividi') && !(navigator.share && ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0))) {
                        if (target.closest('.gz-more-share').dataset.shareposition) {
                            eventAnalytics('Condividi', 'Interazione', 'Click bottone ' + target.closest('.gz-more-share').dataset.shareposition);
                        }
                        break;
                    }

                    if (target.matches('.gz-button-fotocommenti')) {
                        event.preventDefault();

                        if (target.dataset.shareposition) {
                            if(target.matches('.add-fotocommenti')) {
                                eventAnalytics('Invia foto', 'Interazione', 'Click bottone ' + target.dataset.shareposition);
                            } else {
                                eventAnalytics('Fatte da voi - ancora', 'Interazione', 'Click bottone ' + target.dataset.shareposition);
                            }
                        } 

                        if(target.matches('.add-fotocommenti')) {
                            let setModalCheckEmail = new CustomEvent("setModalCheckEmail", {
                                detail: {
                                    action: "fotocommenti",
                                    modal: true
                                }
                            });
                            document.dispatchEvent(setModalCheckEmail);
                        }
                        break;
                    }

                    if (target.matches('.gz-button-commenti') && !target.matches('.add-commenti')) {
                        event.preventDefault();

                        if (target.dataset.shareposition) {
                            eventAnalytics('Commenti - ancora', 'Interazione', 'Click bottone ' + target.dataset.shareposition);
                        }
                    }
                    
                    if (target.matches('.add-commenti')) {
                        event.preventDefault();

                        if (target.dataset.shareposition) {
                            eventAnalytics('Commento', 'Interazione', 'Click bottone ' + target.dataset.shareposition);
                        }

                        let setModalCheckEmail = new CustomEvent("setModalCheckEmail", {
                            detail: {
                                action: "commenti",
                                modal: true
                            }
                        });
                        document.dispatchEvent(setModalCheckEmail);
                        break;
                    }

                    if (target.matches('.add-lista-spesa')) {
                        event.preventDefault();

                        eventAnalytics('Lista spesa', 'Interazione', 'Click bottone');

                        let setModalCheckEmail = new CustomEvent("setModalCheckEmail", {
                            detail: {
                                action: "listaspesa",
                                modal: false
                            }
                        });
                        document.dispatchEvent(setModalCheckEmail);
                        break;
                    }
                }
            }, false);
        }
    }
})();

(reportMessages = () => {
    let rm = reportMessages;

    rm.init = () => {
        rm.reportModalDefaultUrl = "http://www.giallozafferano.it/staff/segnalazioni";
        rm.reportModalLink = document.getElementById("gz-modal-report-link");

        document.addEventListener('click', function (event) {
            for (var target = event.target; target && target != this; target = target.parentNode) {
                if (target.matches('.gz-report-link')){
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    rm.setupReportModal(target);
                    modal.openModal("report-box");
                }                
            }
        }, false);

        document.addEventListener('closeModal',function(event){
            if (event.detail.modal_name == "report-box") { 
                rm.resetReportModal();
            }
        });    
    }

    rm.setupReportModal = (item) => {
        let url = rm.reportModalDefaultUrl + `?id=${item.dataset.reportId}&type=${item.dataset.reportType}`;
        rm.reportModalLink.setAttribute('href', url);
    }

    rm.resetReportModal = () => {
        rm.reportModalLink.setAttribute('href', rm.reportModalDefaultUrl);
    }

    rm.init();
})();

function anchorLink(anchor) {
    var element = document.querySelector(anchor),
        offsetPosition = element.offsetTop;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}

function loadSwiperHelper() {
    return mmLoader({
        src: gz_domain + "/js/swiper.min.js?cb=" + nonce,
        defer: true
    }, "swiperChain").then(
        element => mmLoader({
            src: gz_domain + "/js/min/swiperHelper.min.js?cb=" + nonce,
            defer: true
        }, "swiperChain")
    ).then(
        element => {
            swiperHelper = new swiperHelper();
        }
    );
}
/* end utility methods */

function ratingContent(element) {
    /*if(typeof Rating === "undefined") { Rating = {}; }*/
    var me = this;
    me.items = [],
        me.userHasVoted = false,
        me.localStorageSupport = false,
        me.contentId,
        me.contentRate,
        me.voteBtn,
        me.ratingPanel,
        me.ratingCurrentPlaceholder,
        me.wrapCat;

    me.init = function () {
        me.ratingPanel = element;
        me.voteBtn = me.ratingPanel.querySelectorAll('.rating_vote_btn');
        me.ratingCurrentPlaceholder = me.ratingPanel.querySelectorAll('.rating_current');
        me.wrapCat = element.parentNode;

        var tmpItems = me.ratingPanel.querySelectorAll(".rating_item");

        if (!me.ratingPanel) {
            return false;
        }

        me.contentId = me.ratingPanel.dataset.contentId;
        me.contentRate = me.ratingPanel.dataset.contentRate;

        if (typeof (localStorage) !== "undefined") {
            me.localStorageSupport = true;
        }

        if (me.localStorageSupport && localStorage.getItem("content-" + me.contentId)) {
            me.userHasVoted = true;

            if (!me.contentRate) {
                me.contentRate = localStorage.getItem("content-" + me.contentId);
            }
        } else {
            me.enableVoteMode();
        }

        me.setRatingCurrentPlaceholder(me.contentRate);

        for (var i = 0; i < tmpItems.length; i++) {
            var item = tmpItems[i];
            me.items.push(item);
            me.attachEvents(item);
        }

        me.wrapCat.classList.add("panel_enabled");
    };

    me.enableVoteMode = function () {
        me.wrapCat.classList.add("vote_enabled");

        if (!me.contentRate) {
            me.wrapCat.classList.add("no_vote");
        }

        me.voteBtn[0].addEventListener("click", function (ev) {
            if (me.ratingPanel.classList.contains("vote_opened")) {
                me.ratingPanel.classList.remove("vote_opened");
            } else {
                me.ratingPanel.classList.add("vote_opened");
            }
        });
    };

    me.iterate = function (collection, callback) {
        for (var i = 0; i < collection.length; i++) {
            var item = collection[i];
            callback(item, i);
        }
    };

    me.attachEvents = function (item) {
        item.addEventListener("mouseover", me.itemMouseOver);
        item.addEventListener("mouseout", me.itemMouseOut);
        item.addEventListener("click", me.itemClick);
    };

    me.itemMouseOver = function (ev) {
        var currentItem = ev.target;
        me.iterate(me.items, function (item, index) {
            if (index <= parseInt(currentItem.getAttribute("data-index"))) {
                item.classList.add("rating_active");
            } else {
                item.classList.remove("rating_active");
            }
        });
    };

    me.itemMouseOut = function (ev) {
        if (me.items.indexOf(ev.relatedTarget) === -1) {
            me.setRating(null, false);
        }
    };

    me.itemClick = function (ev) {
        ev.preventDefault();

        var currentItem = ev.target;
        me.setRating(parseInt(currentItem.getAttribute('data-index')) + 1, me.registerVote);
    };

    me.setRating = function (value, callback) {
        if (value && value < 0) {
            return;
        }

        if (value) {
            me.iterate(me.items, function (item, index) {
                if (index < value) {
                    item.classList.add('rating_setted');
                } else {
                    item.classList.remove('rating_setted');
                }
            });

            if (callback) {
                callback(value);
            }
        } else {
            me.iterate(me.items, function (item, index) {
                if (index < 0) {
                    item.classList.add('rating_active');
                } else {
                    item.classList.remove('rating_active');
                }
            });
        }
    };

    me.getRating = function () {
        return me.contentRate;
    };

    me.registerVote = function (value) {
        var data = "id=" + me.contentId + "&rate=" + value;

        localStorage.setItem("content-" + me.contentId, value);
        me.userHasVoted = true;

        //document.querySelectorAll('.gz-wrap-rating').forEach(function(item){
        element.parentNode.classList.remove("no_vote");
        element.parentNode.classList.remove("vote_enabled");
        //});

        //document.querySelectorAll('.rating_panel').forEach(function(item, index, e){
        element.classList.remove("vote_opened");
        element.classList.add("voted");
        //console.log(element.parentNode.classList)
        //});


        fetch('/ajax/rating.php?' + data, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "id": me.contentId,
                    "rate": value
                }),
            }).then(res => {
                return res.json();
            })
            .then(response => {
                if (response.status == "true") {
                    me.setRatingCurrentPlaceholder(response.rating);
                    eventAnalytics('Voto', 'Rating', window.location.href, false, value);
                } else {
                    me.setRatingCurrentPlaceholder(value);
                    eventAnalytics(response.msg, 'Rating', window.location.href, false, value);
                }
            });
    };

    me.setRatingCurrentPlaceholder = function (rating) {
        if (document.querySelectorAll('.mm-infinite-content').length) {
            document.querySelectorAll(`[data-content-id="${element.getAttribute('data-content-id')}"] .rating_current`)[0].innerHTML = rating;
        } else {
            document.querySelectorAll('.rating_current').forEach(function (item) {
                item.innerHTML = rating;
            });
        }

    };
};

function loadingComments(button) {
    var comments_wrap = document.querySelector('.gz-comments-wrap'),
        comments = comments_wrap.children,
        total_comments = comments_wrap.dataset.commentsTotal,
        start = comments.length,
        add_comment = document.querySelector('.gz-comment-foot > .add-commenti'),
        recipe_id = document.body.dataset.recipe;

    comments_wrap.classList.add('gz-loading');

    fetch(`/ajax/comment-more.php?id=${recipe_id}&start=${start}`)
        .then(res => {
            return res.text()
        })
        .then(response => {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            comments_wrap.insertAdjacentHTML('beforeend', response);
            comments_wrap.classList.remove('gz-loading');
            window.scrollTo(0, scrollTop);
            add_comment.classList.add('gz-comment-enabled');

            var displayed = comments_wrap.children.length;

            button.querySelector(':scope .count-comments').innerHTML = total_comments - displayed;

            if (displayed == total_comments) {
                button.style.display = 'none';
            }
        });
}

function appendPhotoComments() {
    let templatePhotoComments = document.querySelector('#gz-photocomments-template');
    //attivo il template
    document.getElementById('gz-photocomments-anchor').appendChild(templatePhotoComments.content.cloneNode(true));

    //init di swiperHelper
    if (typeof (swiperHelper) === "undefined") {
        let isSwiperLoaded = loadSwiperHelper();
        isSwiperLoaded.then(() => {
            swiperHelper.init();
            document.getElementById('gz-photocomments-anchor').addEventListener('click', (event) => {
                var reportLink = event.target.closest('.gz-report-link');
                if(reportLink) {
                    return;
                }

                var target = event.target.closest('.gz-card');

                if (target) {
                    target.classList.toggle('opened');
                }
            });
        });
    } else {
        swiperHelper.init();
        document.getElementById('gz-photocomments-anchor').addEventListener('click', (event) => {
            var reportLink = event.target.closest('.gz-report-link');
            if(reportLink) {
                return;
            }

            var target = event.target.closest('.gz-card');

            if (target) {
                target.classList.toggle('opened');
            }
        });
    }
}

function activateTemplatePodcast() {
    var templateBox = document.querySelector('#gz-podcast-template');
    document.body.appendChild(templateBox.content.cloneNode(true));
}

function loadingPhotoComments() {
    var me = this;
    me.id = document.body.dataset.recipe,
        me.total = document.querySelector('.gz-photocomments-wrapper').dataset.total;

    me.init = () => {
        me.gui();

        var offset = document.querySelectorAll('.gz-photocomments-wrapper .gz-swiper-slide').length;
        if (offset != me.total) {
            me.ajaxCall(me.id, offset);
        }
    }

    me.gui = () => {
        var that = this;

        swiperHelper.swipers["gz-photocomments-swiper"].swiper.on('slideChange', (event) => {
            var activeIndex = swiperHelper.swipers["gz-photocomments-swiper"].swiper.activeIndex,
                offset = document.querySelectorAll('.gz-photocomments-wrapper .gz-swiper-slide').length;

            if ((offset - activeIndex == 4) && offset != me.total) {
                me.ajaxCall(that.id, offset);
            }
        });
    }

    me.ajaxCall = (id, offset) => {
        var params = `recipe_id=${id}&offset=${offset}&num=4`;

        fetch(`//ricette.giallozafferano.it/ajax/photocomments-more.php?${params}`)
            .then(res => {
                return res.text()
            })
            .then(response => {
                swiperHelper.swipers["gz-photocomments-swiper"].swiper.appendSlide(response);
                swiperHelper.swipers["gz-photocomments-swiper"].swiper.update();
            });
    }
}

function recipeTime(recipe_time) {
    if (recipe_time > 60) {
        if (recipe_time % 60) {
            return Math.floor(recipe_time / 60) + ' h ' + (recipe_time % 60) + ' min';
        } else {
            return Math.floor(recipe_time / 60) + ' h';
        }
    } else {
        return recipe_time + ' min';
    }
}

function relatedRecipes() {
    var me = this;
    me.initialized = false;

    me.init = function () {
        me.relatedContainer = document.querySelector('.gz-overlay-related');
        me.relatedTrigger = document.querySelector('.gz-featured-image-video.gz-type-photo');
        me.gui();
    };

    me.gui = function () {
        me.relatedTrigger.insertAdjacentHTML('beforeend', `<span class="more-related-recipes">${dictionary.moreSimilarRecipes}</span>`);
        me.relatedContainer.insertAdjacentHTML('beforeend', me.structureRelated());

        me.relatedTrigger.addEventListener('click', event => {
            event.preventDefault();
            me.relatedContainer.classList.toggle('opened');
            eventAnalytics('SliderOpened', 'SliderFotoRicette', '-');

            if (!me.initialized) {
                fetch('/ajax/related-recipes.php?id=' + document.body.dataset.recipe)
                    .then(response => {
                        return response.json()
                    })
                    .then(data => {
                        if (typeof (swiperHelper) === "undefined") {
                            let isSwiperLoaded = loadSwiperHelper();
                            isSwiperLoaded.then(() => {
                                swiperHelper.init();
                                swipersJSON['gz-related'] = data;
                                swiperHelper.setupSwipers();
                                me.initRelated();
                            });
                        } else {
                            swipersJSON['gz-related'] = data;
                            swiperHelper.setupSwipers();
                            me.initRelated();
                        }
                    });
            }
        });

        me.relatedContainer.querySelector('.gz-overlay-related-close').addEventListener('click', event => {
            event.preventDefault();
            me.relatedContainer.classList.toggle('opened');
            eventAnalytics('SliderClosed', 'SliderFotoRicette', '-');
        });

        for (const item of me.relatedContainer.querySelectorAll('.gz-overlay-related-single a')) {
            item.addEventListener('click', event => {
                eventAnalytics('SliderClicked', 'SliderFotoRicette', item.getAttribute('href'));
            });
        }
    };

    me.initRelated = function () {
        var that = this,
            swipers = swiperHelper.getSwipers(),
            name = 'gz-related',
            target = swipers[name].target;

        swipers[name]["swiper"] = that.initSwiper(target);
        that.initialized = true;
        let initSwiperEvent = new CustomEvent('initSwiper', {
            'detail': {
                swipername: name
            }
        });
        document.dispatchEvent(initSwiperEvent);
    };

    me.buildSlides = function (name) {
        var slides = [];

        for (var i = 0; i < swipersJSON[name].length; i++) {
            var card = swipersJSON[name][i],
                isBenessere = card["benessere"],
                colorIcons = (isBenessere && lang == 'it') ? "-green" : "",
                slide = '';

            slide += '<li class="swiper-slide gz-overlay-related-single">' +
                '<div class="gz-overlay-related-single-head">' +
                '<div class="gz-overlay-related-count-slide"><span>' + (i + 1) + '</span> | ' + swipersJSON[name].length + '</div>' +
                '<div class="gz-overlay-related-title"><a href="' + card["link"] + '">' + card["name"] + '</a></div>' +
                '</div>' +
                '<div class="gz-overlay-related-single-content">' +
                '<a href="' + card["link"] + '"><picture>' +
                '<img src="' + card["image"]['540x360'] + '" alt="' + card["name"] + '" class="lazyload" loading="lazy">' +
                '</picture></a>' +
                '<div class="gz-overlay-related-single-description">' +
                '<div class="gz-overlay-related-abstract">' + card["desc_google"] + '</div>' +
                '<div class="gz-overlay-related-data">' +
                '<ul>';
            if (card["summary"]["difficulty"]) {
                slide += '<li>' +
                    '<span class="gz-icon">' +
                    '<svg viewBox="0 0 16 16">' +
                    '<use xlink:href="/style/images/icons-foglia.svg?cb=' + nonce + '#difficolta' + colorIcons + '" />' +
                    '</svg>' +
                    '</span>' +
                    '<span class="gz-overlay-related-data-name">' + dictionary.skillDifficulty + '<strong> ' + card["summary"]["difficulty_str"] + '</strong></span>' +
                    '</li>';
            }
            if (card["summary"]["prep_time"]) {
                slide += '<li>' +
                    '<span class="gz-icon gz-icon-preparazione">' +
                    '<svg viewBox="0 0 14 17">' +
                    '<use xlink:href="/style/images/icons-foglia.svg?cb=' + nonce + '#preparazione' + colorIcons + '" />' +
                    '</svg>' +
                    '</span>' +
                    '<span class="gz-overlay-related-data-name">' + dictionary.skillPreparation + '<strong> ' + recipeTime(parseInt(card["summary"]["prep_time"])) + '</strong></span>' +
                    '</li>';
            }
            if (card["summary"]["cook_time"]) {
                slide += '<li>' +
                    '<span class="gz-icon">' +
                    '<svg viewBox="0 0 14 14">' +
                    '<use xlink:href="/style/images/icons-foglia.svg?cb=' + nonce + '#cottura' + colorIcons + '" />' +
                    '</svg>' +
                    '</span>' +
                    '<span class="gz-overlay-related-data-name">' + dictionary.skillCookingTime + '<strong> ' + recipeTime(parseInt(card["summary"]["cook_time"])) + '</strong></span>' +
                    '</li>';
            }
            if (card["summary"]["serving"]) {
                slide += '<li>' +
                    '<span class="gz-icon">' +
                    '<svg viewBox="0 0 15 13">' +
                    '<use xlink:href="/style/images/icons-foglia.svg?cb=' + nonce + '#dosi' + colorIcons + '" />' +
                    '</svg>' +
                    '</span>' +
                    '<span class="gz-overlay-related-data-name">' + dictionary.skillServes + '<strong> ' + card["summary"]["serving"] + '</strong></span>' +
                    '</li>';
            }
            if (card["summary"]["cost"]) {
                slide += '<li>' +
                    '<span class="gz-icon">' +
                    '<svg viewBox="0 0 15 15">' +
                    '<use xlink:href="/style/images/icons-foglia.svg?cb=' + nonce + '#costo' + colorIcons + '" />' +
                    '</svg>' +
                    '</span>' +
                    '<span class="gz-overlay-related-data-name">' + dictionary.skillCost + '<strong> ' + card["summary"]["cost_str"] + '</strong></span>' +
                    '</li>';
            }
            if (card["summary"]["remarks"]) {
                slide += '<li class="remarks">' +
                    '<span class="gz-icon">' +
                    '<svg viewBox="0 0 16 16">' +
                    '<use xlink:href="/style/images/icons-foglia.svg?cb=' + nonce + '#nota' + colorIcons + '" />' +
                    '</svg>' +
                    '</span>' +
                    '<span class="gz-overlay-related-data-name"><strong>' + dictionary.skillNote + '</strong> ' + card["summary"]["remarks"] + '</span>' +
                    '</li>';
            }
            slide += '</ul>' +
                '</div>';
            if (card["benessere_tags"]) {
                slide += '<div class="gz-overlay-related-tag-icon">' +
                    '<ul>';
                for (val of card["benessere_tags"]) {
                    //skip nichel
                    if (val.slug != 'benessere-basso-nichel') {
                        slide += '<li>' +
                            '<span class="gz-icon">' +
                            '<svg viewBox="0 0 25 26">' +
                            '<use xlink:href="/style/images/icons-foglia.svg?cb=' + nonce + '#foglia-' + val.slug + '-white' + colorIcons + '" />' +
                            '</svg>' +
                            '</span>' +
                            '</li>';
                    }
                }
                slide += '</ul>' +
                    '</div>';
            }
            slide += '</div>' +
                '</div>' +
                '</li>';
            slides.push(slide);
        }
        return slides;
    };

    me.initSwiper = function (target) {
        var swiper = new Swiper(target, {
            breakpointsInverse: true,
            navigation: {
                nextEl: target.parentNode.querySelector(':scope .gz-swiper-button-next'),
                prevEl: target.parentNode.querySelector(':scope .gz-swiper-button-prev'),
            },
            loop: target.dataset.swiperloop || false,
            slidesPerView: "auto",
            simulateTouch: false,
            on: {
                init: function () {
                    target.classList.toggle('gz-loading');
                },
                slideNextTransitionEnd: function () {
                    eventAnalytics('SliderNext', 'SliderFotoRicette', swiper.activeIndex + 1);
                },
                slidePrevTransitionEnd: function () {
                    eventAnalytics('SliderPrev', 'SliderFotoRicette', swiper.activeIndex + 1);
                },
            }
        });

        return swiper;
    };

    me.structureRelated = function () {
        var html = '<div class="gz-loading swiper-container gz-swiper-container" data-swipername="gz-related" data-swipertype="json" data-swipercallback="relatedslides">' +
            '<ul class="swiper-wrapper gz-swiper-wrapper gz-overlay-related-list"></ul>' +
            '</div>' +
            '<div class="gz-overlay-related-arrows">' +
            '<span class="gz-overlay-related-arrow-prev gz-swiper-button-prev">' +
            '<span class="gz-icon gz-icon-arrow-left"></span></span>' +
            '<span class="gz-overlay-related-arrow-next gz-swiper-button-next">' +
            '<span class="gz-icon gz-icon-arrow-right"></span></span>' +
            '</div>' +
            '<div class="gz-overlay-related-close">' +
            '<span class="gz-icon gz-icon-close gz-icon-close-white"></span>' +
            '</div>';
        return html;
    }
}

function relatedslides(name) {
    return related.buildSlides(name);
}

function addRaccomandatoreGetter() {
    console.log('[Raccomandatore] Consent Given');
    postTcfReady(startGetter);

    async function startGetter() {
        if (!itemsRaccomandatore) {
            let items = getCookieCommon("raccomandatore") || null;
            if (items) {
                localStorage.setItem('raccomandatore', encodeURIComponent(items));
            } else {
                if (localStorage.getItem('raccomandatore')) items = localStorage.getItem('raccomandatore');
            }

            let kxkuid = localStorage.getItem('kxkuid') || null;
            let localEtsId = localStorage.getItem('localEtsId') || null;
            let urlRewrited  = document.location.pathname.replace('/', '').replace('.html', '') || null;
            let jsonToPost = {};
            jsonToPost.items = [];

            if (items) {
                items = JSON.parse(decodeURIComponent(items))

                if(items.items && items.items.length > 0){
                    jsonToPost = items;

                    jsonToPost.items = jsonToPost.items.filter((item)=>{
                        if(item.urlRewrited.indexOf(' ') === -1 && item.urlRewrited.indexOf('%20') === -1) {
                            return item;
                        }
                    });
                } 
            } 

            if(jsonToPost.items.length == 0 && urlRewrited && urlRewrited.indexOf(' ') === -1 && urlRewrited.indexOf('%20') === -1) {
                jsonToPost.items.push({
                    urlRewrited: urlRewrited,
                    occ: 1,
                    lts: Math.floor(Date.now()/1000)
                });
            }

            jsonToPost.ids = {
                "uid": localEtsId,
                "kx": kxkuid
            };
            jsonToPost.ctx = "leaf"; 
            jsonToPost.page = 0;
            jsonToPost.url = document.location.href;

            console.log('[Raccomandatore] jsonToPost', jsonToPost);
            console.log('[Raccomandatore] jsonToPost1', JSON.stringify(jsonToPost));

            if(jsonToPost.items.length > 0) {
                let response = await fetch('https://x77l9u4vif.execute-api.eu-west-1.amazonaws.com/prod/api/recommender/gz/v1/leaf/', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(jsonToPost)
                });
    
                itemsRaccomandatore = await response.json();
                console.log('[Raccomandatore] Risultati Fetch Leaf', itemsRaccomandatore);
    
                initRaccomandatore();
            }
        } else {
            initRaccomandatore();
        }
    }

    function initRaccomandatore() {
        var raccomandatore = new raccomandatoreHandler(itemsRaccomandatore);
        raccomandatore.init();
    }
}

function raccomandatoreHandler(res) {
    var me = this;
    me.placeholder;
    me.data;

    me.init = () => {
        me.placeholder = document.getElementById('gz-raccomandatore-foglia');
        me.data = res ? res['nodo_out'] : null;

        if (!me.data || !me.placeholder) {
            return;
        }

        me.skills = {
            1: dictionary.skillVeryEasy,
            2: dictionary.skillEasy,
            3: dictionary.skillMedium,
            4: dictionary.skillDifficult,
            5: dictionary.veryDifficult
        };

        if (me.placeholder) {
            me.populateData();
        }
    };

    me.populateData = () => {
        var html = '';

        for (var i = 0; i < me.data.length; i++) {
            if (showLeafAds && !status2 && i < 15) {
                if (device == "desktop") {
                    if (i == 3 || (i > 6 && (i % 3 == 0))) {
                        html += '<div class="gz-adv-slot gz-adv-adsense-bottom gz-mBottom3x"><div class="gz-adv-adsense" id="ricettaBottom"><ins class="adsbygoogle" style="display:block" data-ad-format="fluid" data-ad-layout-key="-f7-7k+gq+b5-17f" data-ad-client="ca-pub-0820544532937748" data-ad-slot="9825878232"></ins></div></div>';
                    }

                    if (i == 6) {
                        html += '<div class="gz-adv-slot gz-adv-outbrain gz-adv-outbrain-bottom gz-mBottom3x"><div class="gz-adv"><div class="OUTBRAIN" data-src="' + document.querySelector('meta[property="og:url"]').getAttribute('content') + '" data-widget-id="AR_1" data-ob-template="giallozafferano" ></div></div></div>';
                    }
                } else {
                    if (i == 3 || (i > 12 && (i % 3 == 0))) {
                        html += '<div class="gz-adv-slot gz-adv-adsense-bottom gz-mBottom3x"><div class="gz-adv-adsense" id="ricettaBottom"><ins class="adsbygoogle" style="display:inline-block;width:300px;height:250px;" data-ad-client="ca-pub-0820544532937748" data-ad-slot="2393033968"></ins></div></div>';
                    }

                    if (i == 6) {
                        html += '<div class="gz-adv-slot gz-adv-outbrain gz-adv-outbrain-bottom gz-mBottom3x"><div class="gz-adv"><div class="OUTBRAIN" data-src="' + document.querySelector('meta[property="og:url"]').getAttribute('content') + '" data-widget-id="AR_1" data-ob-template="giallozafferano" ></div></div></div>';
                    }

                    if (i == 9) {
                        html += '<div class="gz-adv-slot"><div class="gz-adv" id="gpt_native_sidebar1_mobile"></div><div class="gz-adv" id="gpt_native_sidebar2_mobile"></div></div>';
                    }

                    if (i == 12) {
                        html += '<div class="gz-adv-slot"><div class="gz-adv" id="gpt_native_sidebar3_mobile"></div><div class="gz-adv gpt_fluid_mobile" id="gpt_fluid_mobile"></div></div>';
                    }
                }
            }

            if(i < 15) {
                var el = me.createCard(me.data[i], i);
                html += el;
            }
        }

        me.placeholder.innerHTML = me.placeholder.innerHTML + html;
        me.placeholder.parentNode.classList.add('processed');
        if(status1 && typeof window['checkCollections'] === 'function') {
            checkCollections.setButtons(me.placeholder);
        }

        if (me.data.length >= 12 && showLeafAds && device != "desktop" && !status2) {
            var gpt_fluid_mobile_mapping = googletag.sizeMapping()
                .addSize([0, 0], ['fluid'])
                .addSize([950, 0], [])
                .build();

            var sizes = ['fluid'];

            gpt_fluid_mobile = googletag.defineSlot(MMsezioneTag, sizes, "gpt_fluid_mobile")
                .setCollapseEmptyDiv(true)
                .addService(googletag.pubads());
            gpt_fluid_mobile.defineSizeMapping(gpt_fluid_mobile_mapping);
            googletag.display("gpt_fluid_mobile");
        }

        if (!status2) {
            adsenseCheck();
            
            /*
            if (initOutbrainDone) {
                setTimeout(() => {
                    OBR.extern.researchWidget();
                }, 300);
            }
            */
        }

        // evento click sui suggeriti
        for (const el of me.placeholder.querySelectorAll('.gz-card-suggested a')) {
            el.addEventListener('click', event => {
                var index = parseInt(el.closest('.gz-card-suggested').dataset.index) + 1;
                var href = el.getAttribute('href');
                var tipo = el.closest('.gz-card-suggested').dataset.etsTipo;
                eventAnalytics('Click', 'SuggeritiFoglia', index + '#' + tipo + '#' + href);
            });
        }
    };

    me.createCard = (el, index) => {
        var html = '';
        var sp = ''; //GZ-1992 el.t_has_special_image ? '_sp' : '';

        if (el.tipo == "O") {
            // funtip
            html += '<article class="gz-card gz-card-horizontal gz-vertical-view gz-card-suggested gz-mBottom3x" data-ets-algo="' + el.algo + '" data-ets-tipo="' + el.tipo + '" data-index="' + index + '">' +
                '<div class="gz-card-image">' +
                '<a href="' + el.url + '" title="' + el.titolo + '">' +
                '<picture>' +
                '<img src="' + el.img + '" width="400" height="400" alt="' + el.titolo + '" class="lazyload" loading="lazy" />' +
                '</picture>' +
                '<span class="gz-icon gz-btn-icon gz-action-icon gz-action-icon-play"><svg viewBox="0 0 50 50"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#icon-playbutton" /></svg></span>';

            // if(el.benessere && !el.label) {
            if (el.benessere) {
                html += '<div class="gz-label gz-btn-link gz-benessere"><span class="gz-icon gz-btn-icon"><svg viewBox="0 0 50 50"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#icon-benessere" /></svg></span><span class="gz-btn-label">' + dictionary.benessere + '</span></div>';
            }
            html += '</a>' +
                '<div class="gz-btn-link gz-add-preferiti gz-add-preferiti-processed" data-recipeid="' + el.id + '"><span class="gz-btn-icon gz-icon"></span></div>' +
                '</div>' +
                '<div class="gz-card-content">';
            html += '<div class="gz-category"><a href="https://funtip.giallozafferano.it/" title="' + dictionary.recipesInAMinute + '">' + dictionary.recipesInAMinute + '</a></div>';
            html += '<h2 class="gz-title"><a href="' + el.url + '" title="' + el.titolo + '">' + el.titolo + '</a></h2>';
            html += '<div class="gz-description">' + (el.desc_google ? ((el.desc_google.slice.length > 150) ? el.desc_google.slice(0, 150) + '...' : el.desc_google) : '') + '</div>';
            if (el.fb_like || el.fb_video_views) {
                html += '<ul class="gz-card-data bottom">';
                if (el.fb_like) {
                    html += '<li class="gz-single-data-recipe">' +
                        '<span class="gz-icon gz-icon-likesocial">' +
                        '<svg viewBox="0 0 18 18">' +
                        '<use xlink:href="/style/images/icons.svg?cb=' + nonce + '#likesocial-blu" />' +
                        '</svg>' +
                        '</span>' +
                        el.fb_like +
                        '</li>';
                }

                if (el.fb_video_views) {
                    html += '<li class="gz-single-data-recipe">' +
                        '<span class="gz-icon gz-icon-view">' +
                        '<svg viewBox="0 0 21 12">' +
                        '<use xlink:href="/style/images/icons.svg?cb=' + nonce + '#view-blu" />' +
                        '</svg>' +
                        '</span>' +
                        el.fb_video_views +
                        '</li>';
                }
                html += '</ul>';
            }
            html += '<div class="gz-col">' +
                '<div class="gz-link-more-recipe">' +
                '<a href="' + el.url + '" title="' + el.titolo + '">' + dictionary.goToVideo + '</a>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</article>';
        } else {
            html += '<article class="gz-card gz-card-horizontal gz-vertical-view gz-card-suggested gz-mBottom3x" data-ets-algo="' + el.algo + '" data-ets-tipo="' + el.tipo + '" data-index="' + index + '">' +
                '<div class="gz-card-image">' +
                '<a href="' + el.url + '" title="' + el.titolo + '">' +
                '<picture>' +
                '<img src="' + el.img + 'foto_hd/hd450x300' + sp + '.jpg" width="450" height="300" alt="' + el.titolo + '" class="lazyload" loading="lazy" />' +
                '</picture>';
            if (el.type == "video") {
                html += '<span class="gz-icon gz-btn-icon gz-action-icon gz-action-icon-play"><svg viewBox="0 0 50 50"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#icon-playbutton" /></svg></span>';
            }

            // if(el.benessere && !el.label) {
            if (el.benessere) {
                html += '<div class="gz-label gz-btn-link gz-benessere"><span class="gz-icon gz-btn-icon"><svg viewBox="0 0 50 50"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#icon-benessere" /></svg></span><span class="gz-btn-label">' + dictionary.benessere + '</span></div>';
            }
            html += '</a>' +
                '<div class="gz-btn-link gz-add-preferiti gz-add-preferiti-processed" data-recipeid="' + el.id + '"><span class="gz-btn-icon gz-icon"></span></div>' +
                '</div>' +
                '<div class="gz-card-content">';
            if (el.cat_link && el.cat_name) {
                html += '<div class="gz-category"><a href="' + el.cat_link + '" title="' + el.cat_name + '">' + el.cat_name + '</a></div>';
            }
            html += '<h2 class="gz-title"><a href="' + el.url + '" title="' + el.titolo + '">' + el.titolo + '</a></h2>';
            if (el.num_commenti || el.rating_average) {
                html += '<ul class="gz-card-data top">';
                if (el.num_commenti) {
                    html += '<li class="gz-single-data-recipe">' +
                        '<a rel="nofollow" href="' + el.url + '#anchor=gz-comments-anchor" title="' + el.titolo + '">';
                    if (el.num_commenti >= 200) {
                        html += '<span class="gz-icon"><svg viewBox="0 0 17 18"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#commento-orange" /></svg></span>';
                    } else {
                        html += '<span class="gz-icon"><svg viewBox="0 0 24 25"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#commento-grey" /></svg></span>';
                    }
                    html += el.num_commenti +
                        '</a>' +
                        '</li>';
                }

                if (el.rating_average) {
                    html += '<li class="gz-single-data-recipe">' +
                        '<a href="' + el.url + '" title="' + el.titolo + '">';
                    if (el.rating_average >= 4.3) {
                        html += '<span class="gz-icon"><svg viewBox="0 0 18 16"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#voto-orange" /></svg></span>';
                    } else {
                        html += '<span class="gz-icon"><svg viewBox="0 0 21 20"><use xlink:href="/style/images/icons.svg?cb=' + nonce + '#voto-grey" /></svg></span>';
                    }
                    html += el.rating_average +
                        '</a>' +
                        '</li>';
                }
                html += '</ul>';
            }
            html += '<div class="gz-description">' + (el.desc_google ? ((el.desc_google.slice.length > 150) ? el.desc_google.slice(0, 150) + '...' : el.desc_google) : '') + '</div>';
            if (el.difficolta || el.totale_tempo_cottura || el.nutritional_kcal) {
                html += '<ul class="gz-card-data bottom">';
                if (el.difficolta) {
                    html += '<li class="gz-single-data-recipe">' +
                        '<span class="gz-icon">' +
                        '<svg viewBox="0 0 19 19">' +
                        '<use xlink:href="/style/images/icons.svg?cb=' + nonce + '#difficolta-grey" />' +
                        '</svg>' +
                        '</span>' +
                        me.skills[parseInt(el.difficolta)] +
                        '</li>';
                }

                if (el.totale_tempo_cottura) {
                    html += '<li class="gz-single-data-recipe">' +
                        '<span class="gz-icon">' +
                        '<svg viewBox="0 0 20 19">' +
                        '<use xlink:href="/style/images/icons.svg?cb=' + nonce + '#tempo-grey" />' +
                        '</svg>' +
                        '</span>' +
                        recipeTime(parseInt(el.totale_tempo_cottura)) +
                        '</li>';
                }
                if (el.nutritional_kcal) {
                    html += '<li class="gz-single-data-recipe">' +
                        '<span class="gz-icon">' +
                        '<svg viewBox="0 0 19 20">' +
                        '<use xlink:href="/style/images/icons.svg?cb=' + nonce + '#kcal-grey" />' +
                        '</svg>' +
                        '</span>' +
                        'Kcal ' + parseInt(el.nutritional_kcal) +
                        '</li>';
                }
                html += '</ul>';
            }
            html += '<div class="gz-col">' +
                '<div class="gz-link-more-recipe">' +
                '<a href="' + el.url + '" title="' + el.titolo + '">' + dictionary.readMore + '</a>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</article>';
        }

        return html;
    };
}

function addDisclaimer() {
    let disclaimerButton = document.getElementById('gz-more-disclaimer');
    let disclaimerText = document.getElementById('gz-ingredients-disclaimer-text');

    if (disclaimerButton && disclaimerText) {
        let text = document.createElement('p');
        text.innerHTML = "GialloZafferano is the most important Italian digital brand in terms of food and its recipes are studied and designed to be easily made with granted results. The rigorous method we use to prepare our recipes starts form the usage of correct ingredients quantities, that must be combined following our directions. We are presenting our ingredients using also USA measures (tbsp, cups, etc) to help foreign visitors that use this measure system. Anyway it rounds up European doses introducing some approximation errors that should be fixed during the preparation. To get the best results, we recommend our readers to preparare the ingredients by using the European quantities (g,Kg, ml, ecc.).";
        disclaimerText.appendChild(text);
        disclaimerButton.classList.add('processed');
    }
}

let adsenseInfinitePush = () => {
    let adsense_slots = document.querySelectorAll(".adsbygoogle:not(.processed)");
    if (adsense_slots.length > 0) {
        for (var i = 0; i < adsense_slots.length; i++) {
            adsense_slots[i].classList.add('processed');
            (adsbygoogle = window.adsbygoogle || []).push({});
        }
    }
}

window.addEventListener('mmInfiniteScroll', function (data) {
    if (status2) {
        handleUserCommon.customizeSidebar();
    }

    if (initAdsenseDone) {
        adsenseInfinitePush();
    } else {
        document.addEventListener('loadedAdsense', () => {
            adsenseInfinitePush();
        });
    }
});